import React from 'react'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Reusable Toast Service
const ToastService = {
  success: (message) => toast.success(message),
  error: (message) => toast.error(message),
  info: (message) => toast.info(message),
  warning: (message) => toast.warning(message),
}

export const ToastProvider = () => {
  return <ToastContainer position="top-right" autoClose={1000} hideProgressBar />
}

export default ToastService
